import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import db, { storage } from "../firebase";
import { useHistory } from "react-router-dom";
import { Table } from "react-bootstrap";
import Select from "react-select";

import { notify } from "react-notify-toast";

const ViewMenu2 = ({ user, role, mid, bid }) => {
  const [branch, setBranch] = useState({ id: "null", data: [{}] });
  const [product, setProduct] = useState([]);
  const [branchId, setBranchId] = useState("");
  const [option, setOption] = useState([]);
  const [isDisable, setIsDisable] = useState(false);
  const [selectedMerchant, setselectedMerchant] = useState("");
  const [merchants, setmerchants] = useState([]);
  const [selectedbranch, setselectedbranch] = useState("");
  const history = useHistory();

  useEffect(async () => {
    let user = JSON.parse(localStorage.getItem("Ubytes"));
    if (user.role === "Branch") {
      setBranchId(user.of);
      let products = await db
        .collection("Products")
        .where("of", "==", user.of)
        .get();

      let productList = [];
      products.forEach((product) => {
        productList.push(product.data());
      });
      setProduct(productList);
      setIsDisable(true);
    } else if (user.role === "Merchant") {
      let options_ = [];
      let branches = await db
        .collection("Branches")
        .where("of", "==", user.of)
        .get();
      branches.forEach((br) => {
        let _ = br.data();
        _["value"] = br.data().branchId;
        _["label"] = br.data().branchName;
        options_.push(_);
      });
      setOption(options_);
    } else if (user.role === "Superadmin") {
      let merchant = await db.collection("Merchant").get();
      let merchantList = [];
      merchant.forEach((merch) => {
        let _ = merch.data();
        _["value"] = merch.data().branchId;
        _["label"] = merch.data().brandName;
        merchantList.push(_);
      });
      setmerchants(merchantList);
    }
  }, []);

  useEffect(() => {
    getOption();
  }, [branch]);

  const productHandler = async () => {
    if (branchId === "") {
      notify("Select a branch first", "warning");
    } else {
      let productList = [];
      let payload = JSON.parse(localStorage.getItem("Ubytes"));
      if (payload.role === "Merchant") {
        let products = await db
          .collection("Products")
          .where("ofMerchant", "==", payload.uid)
          .get();
        console.log(payload.uid);
        products.forEach((element) => {
          console.log(element.data());
          productList.push(element.data());
        });
      } else if (payload.role === "Branch") {
        let products = await db
          .collection("Products")
          .where("of", "==", payload.of)
          .get();
        products.forEach((element) => {
          productList.push(element.data());
        });
      }
      console.log(productList);
      setProduct(productList);
    }
  };

  const deleteHandler = async (id) => {
    await db.collection("Products").doc(id).delete();
    notify.show("Product deleted successfully!", "success");
  };

  const getOption = () => {
    const op = [];
    branch.data.map((bran, i) => {
      op.push({ value: branch.id[i], label: bran.branchName });
      setOption(op);
    });
  };

  const branchSelect = (branchId) => {
    let _ = branchId;
    _["value"] = branchId.branchName;
    _["label"] = branchId.branchName;
    setBranchId(_);
  };
  const loadbranch = async (uid) => {
    let data = await db.collection("Branches").where("of", "==", uid).get();
    let branches = [];
    data.forEach((branch) => {
      let _ = branch.data();
      _["value"] = branch.data().branchName;
      _["label"] = branch.data().branchName;
      branches.push(_);
    });
    setOption(branches);
  };
  const searchProduct = async () => {
    let products = await db
      .collection("Products")
      .where("ofMerchant", "==", selectedMerchant.uid)
      .get();
    let productsList = [];
    products.forEach((product) => {
      console.log(product.data());
      if (product.data().of === selectedbranch.branchId) {
        productsList.push(product.data());
      }
    });

    setProduct(productsList);
  };
  return (
    <div className="product_view">
      {JSON.parse(localStorage.getItem("Ubytes")).role == "Branch" ||
      JSON.parse(localStorage.getItem("Ubytes")).role ===
        "Superadmin" ? null : (
        <div className="product_view_form">
          {!isDisable && (
            <Select
              isDisabled={isDisable}
              placeholder="Select Branch"
              value={branchId}
              onChange={branchSelect}
              options={option}
            />
          )}
          <button onClick={productHandler}>
            {isDisable ? "Load Product" : "Search"}
          </button>
        </div>
      )}
      {JSON.parse(localStorage.getItem("Ubytes")).role === "Superadmin" ? (
        <div className="product_view_form">
          <Select
            placeholder="Select  Merchant"
            value={selectedMerchant}
            onChange={(e) => setselectedMerchant(e)}
            options={merchants}
            onBlur={(e) => loadbranch(selectedMerchant.uid)}
            id="select-fghh"
          />
          <Select
            id="select-fghh"
            placeholder="Select Branch"
            value={selectedbranch}
            onChange={(e) => setselectedbranch(e)}
            options={option}
          />

          <button onClick={searchProduct}>Search</button>
        </div>
      ) : null}
      <div className="menu_table_parent">
        <Table striped bordered hover>
          <thead>
            <tr>
              <td>Id</td>
              <td>Product Image</td>
              <td>Product Name</td>
              <td>Product Price</td>
              <td>Edit</td>
              <td>Delete</td>
            </tr>
          </thead>
          <tbody>
            {product.map((prod, index) => {
              return (
                <tr key={prod.productId}>
                  <td>{index + 1}</td>
                  <td>
                    <img
                      src={prod.productImage}
                      width={100}
                      height={100}
                      alt=""
                    />
                  </td>
                  <td>{prod.productName}</td>
                  <td>{prod.productPrice}</td>
                  <td>
                    <button
                      onClick={() =>
                        history.push(`/edit/menu/${prod.productId}`)
                      }
                    >
                      Edit
                    </button>
                  </td>
                  <td>
                    <button onClick={() => deleteHandler(prod.productId)}>
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ViewMenu2;
